import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue";
import _imports_0 from '../../assets/arrow-right.png';
const _hoisted_1 = ["href"];
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    class: "arrow",
    src: _imports_0
};
const _hoisted_4 = { class: "arrow" };
const _hoisted_5 = {
    key: 1,
    class: "mt-3"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'BarArrowButton',
    props: {
        icon: {},
        title: {},
        href: {},
        bold: { type: Boolean },
        disabled: { type: Boolean },
        moreRounded: { type: Boolean },
        large: { type: Boolean },
        centerAlign: { type: Boolean },
        hideArrow: { type: Boolean },
        flex: { type: Boolean },
        bgImage: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass((_ctx.large ? 'large ' : ' ') + 'bar-arrow-button ' + (_ctx.moreRounded ? 'moreRounded ' : ' ')),
                style: _normalizeStyle((_ctx.flex ? 'height: 100%' : ' ') + (_ctx.bgImage ? ';background-image: url(' + _ctx.bgImage + '); background-size: cover; background-repeat: no-repeat; background-position: top; ' : ''))
            }, [
                _createElementVNode("a", { href: _ctx.href }, [
                    (_ctx.title)
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                            default: _withCtx(() => [
                                (_ctx.icon && _ctx.icon != '')
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        class: "icon-col v-col-3"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("img", { src: _ctx.icon }, null, 8, _hoisted_2)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_col, { class: "title-col" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", {
                                            class: _normalizeClass('title ' + (_ctx.bold ? 'bold' : '')),
                                            style: _normalizeStyle((!_ctx.icon ? 'padding-left:20px; ' : ' ') + (_ctx.centerAlign ? 'text-align:center; ' : ' '))
                                        }, _toDisplayString(_ctx.title), 7)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_col, { class: "arrow-col v-col-2" }, {
                                    default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
                                            [_vShow, !_ctx.hideArrow]
                                        ]),
                                        _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
                                            [_vShow, _ctx.hideArrow]
                                        ])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (!_ctx.title)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                        : _createCommentVNode("", true)
                ], 8, _hoisted_1),
                _renderSlot(_ctx.$slots, "default")
            ], 6));
        };
    }
});
